export class SignatoryStamp {
  gId: string;
  signatoryId: string;
  fileName: string;
  signaturePositionPixelX: number;
  signaturePositionPixelY: number;
  signaturePositionX: number;
  signaturePositionY: number;
  signatureSizePixelWidth: number = 185;
  signatureSizePixelHeight: number = 80;
  signatureSizeWidth: number = 48.94;
  signatureSizeHeight: number = 22.39;
  signaturePositionPage: string;
  invalid: boolean;
  default: boolean = false;
}
